<template>
  <div id="app">
    <ThreeDSecure v-if="threeDSecure" />
    <RedirectPage v-else-if="redirect" />
    <Login v-else-if="!authenticated" v-on:logged="catchLogin($event)" />

    <Navbar v-else-if="appReady" />
  </div>
</template>

<script>
import Login from "./ui/pages/Login.vue";
import Navbar from "./ui/layout/Navbar.vue";
import ThreeDSecure from "./ui/pages/ThreeDSecure.vue";
import RedirectPage from "./ui/pages/RedirectPagePalla.vue";
require("@/assets/css/bootstrap.min.css");
require("@/assets/css/style.css");
require("@/assets/css/paper-dashboard.css");

export default {
  name: "App",
  components: {
    Login,
    Navbar,
    ThreeDSecure,
    RedirectPage,
  },

  data: function () {
    return {
      authenticated: false,
      appReady: false,
      threeDSecure: false,
      redirect: false,
    };
  },

  methods: {
    catchLogin: function () {
      this.authenticated = true;
      this.appReady = true;
    },
  },

  beforeMount() {
    if (this.$router.currentRoute.name === "inviteUser") {
      this.redirect = true;
    }
    if (
      new URLSearchParams(document.location.search).get("payment_intent") ||
      this.$router.currentRoute.name === "threed-verification"
    ) {
      this.threeDSecure = true;
    }
  },
};
</script>
